const downloadFile = downloadUrl => {
  const link = `${downloadUrl}?response-content-disposition=attachment`
  // TODO: detect ios version and for iOS >= 11 make it _self
  window.open(link, '_blank')
}

export default downloadFile
